<template>
  <header>
    <nav>
      <div class="centro topo-menu">
        <div class="versao">
          <span>v{{ version }}</span>
        </div>
        <div class="gridbox">
          <div class="usuario">
            <ContadorTempoSessao class="contador-espaco" />
            <p>{{ usuario ? usuario.nome : "TESTE" }}</p>
            <a @click="sair">
              <img
                src="../assets/imagens/icon-exit.svg"
                alt="Sair do Sistema"
                title="sair"
                class="sair"
              />
            </a>
            
          </div>
        </div>
      </div>
    </nav>
    <div class="faixa-menu">
      <div class="icon-mov">
       <div class="logo">
          <img :src="logoSistemaUrl" />
        </div>
        <div class="logo_menu">
          <img :src="logoEnteUrl" />
        </div>
      </div>
      <div class="centro">
        <input id="atv-menu" type="checkbox" />
        <label for="atv-menu">
          <div class="menu">
            <span class="hamburger"></span>
          </div>
        </label>
        <ul id="ulMenu">
          <li>
            <router-link
              v-for="rota in itensMenu"
              :key="rota.name"
              :to="{ name: rota.name }"
              @click.native="menuButtonClick"
            >
              {{ rota.meta.label }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
  import Auth from "../services/Auth";
  import rotasPrivadas from "../router/rotasPrivadas";
  import camelize from "../helpers/camelize";
  import ContadorTempoSessao from "./ContadorTempoSessao.vue";

  const AUTENTICAR_ROUTE = "Autenticar";  

  export default {
    name: "Menu",
    props: {
      enteId: {
        type: [String, Number],
        default: 1
      }
    },
    created() {
      this.auth = new Auth();
    },
    components: {
      ContadorTempoSessao,
    },
    data() {
      return {
        version: process.env.VUE_APP_VERSION,
      };
    },
    methods: {
      menuButtonClick() {
        var inputMenu = document.getElementById("atv-menu");
        setTimeout(() => {
          inputMenu.click();
        }, 500);
      },
      sair() {
        try {
          this.$swal
            .fire({
              title: "Você tem certeza?",
              text: "Informações não salvas serão perdidas",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Sim, sair",
              cancelButtonText: "Não",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.auth.logout();
                this.$router.push({ name: AUTENTICAR_ROUTE });
              }
            });
        } catch (err) {
          console.log(err);
        }
      },
      camelize,
    },
    computed: {
      itensMenu() {
        const auth = new Auth();
        if (!auth || !auth.usuario) return [];
        const func = auth.usuario.funcionalidades || [];

        // 1. Identifica exatamente quem é quem pelas funcionalidades
        const isAdmin = func.includes('colegiados_new_edit_delete') && func.includes('cargos_colegiados_new_edit_delete');
        const isAltaGestao = func.includes('alta_gestao');

        // 2. Separa apenas as rotas que o usuário tem permissão para ver no menu
        let rotasPermitidas = rotasPrivadas.filter(rota => {
          if (!rota.meta || !rota.meta.raiz) return false;
          if (!rota.meta.requerPermissao) return true; // Libera rotas públicas como Fale Conosco
          return func.some(f => rota.meta.permissoes.includes(f));
        });

        // 3. Cria a lista de ordenação vazia
        let ordemEspecifica = [];

        // 4. Preenche a lista com a ordem exata dependendo do perfil
        if (isAdmin) {
          ordemEspecifica = [
            "Colegiados",
            "Acompanhamentos",
            "Home", // (Esta é a rota de Mandatos)
            "Membros",
            "CargoColegiado", // (Cargos)
            "CategoriaRepresentativa", // (Entidades Representativas)
            "StatusMandato",
            "TipoMandato",
            "PainelBI",
            "FaleConosco"
          ];
        } else if (isAltaGestao) {
          ordemEspecifica = [
            "Colegiados",
            "Acompanhamentos",
            "Home", // (Esta é a rota de Mandatos)
            "PainelBI",
            "FaleConosco"
          ];
        } else {
          // Usuários Externos: Mandatos (Home) aparece primeiro
          ordemEspecifica = [
            "Home", // Mandatos em primeiro lugar!
            "Colegiados",
            "PainelBI",
            "FaleConosco"
          ];
        }

        if (ordemEspecifica.length > 0) {
          rotasPermitidas.sort((a, b) => {
            let indexA = ordemEspecifica.indexOf(a.name);
            let indexB = ordemEspecifica.indexOf(b.name);
            
            if (indexA === -1) indexA = 999;
            if (indexB === -1) indexB = 999;

            return indexA - indexB;
          });
        } 
        

        return rotasPermitidas;
      },
      usuario: function () {
        if (this.auth.usuario && this.auth.loggedIn()) {
          return this.auth.usuario;
        }
        return null;
      },
      sistemaSigla() {
      return process.env.VUE_APP_SISTEMA_SIGLA;
    },
      sguApiUrl: function () {
        return process.env.VUE_APP_SGU_API_URL;
      },
          env() {
        return process.env.VUE_APP_ENV;
      },
      logoSistemaUrl() {
      return `${this.sguApiUrl}/storage/${this.env}/logos/sistemas/logo_svg_sistema_${this.sistemaSigla}.svg`
    },
      logoEnteUrl() {
        return `${this.sguApiUrl}/storage/${this.env}/logos/entes/logo_svg_ente_1.svg`
      }
    },
  };
</script>

<style lang="scss" scoped>
 @media screen and (min-width: 1150px) {
    .contador-espaco {
        margin-right: 30px; 
    }
  .gridbox {
    display: grid;
    gap: 0.3rem;
    align-items: flex-end;
    height: max-content;
    margin-top: 0.3rem;
  }
  header {
    .usuario {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0.5rem 0.7rem;

      p {
        margin: 0.1rem 0 0 0;
        font-size: 0.9rem;
        color: white;
      }

      .sair {
        height: 0.9rem;
      }

      a {
        margin-left: 0.5rem;
      }
    }

    .versao {
      margin: 0.5rem 0.7rem;
    }

    nav {
      background-color: #005516;

      .centro {
        display: flex;
        justify-content: space-between;
        max-width: 100%;
        padding: 0;
        align-items: center;
      }

      span {
        color: white;
        font-size: 0.9rem;
      }

      a {
        img {
          height: 1rem;
        }
      }
    }
  }

  .faixa-menu {
    background-color: #005516;

    .centro {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 95rem;
      min-height: 2rem;
      height: auto !important; /* É essa linha que destrava o fundo verde no monitor de 1440px! */
      padding: 0 !important;      /* Adiciona um respiro em cima e embaixo */
    }

    .icon-mov {
      background-color: #efefef;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;
    }

    .logo {
      margin: .3rem 0;
      img {
        height: 4rem;
        width: auto;
      }
    }
    .logo_menu {
      margin: .3rem 0;
      img {
        height: 6rem;
        width: auto;
      }
    }

    .menu {
      border-radius: 50%;
      width: 2rem;
      height: 2rem;
      position: absolute;
      left: 0.5rem;
      top: 3.5rem;
      z-index: 3;
      cursor: pointer;

      .hamburger {
        display: block;
        background-color: #ffa600;
        width: 1.4rem;
        height: 2px;
        position: relative;
        z-index: 12;
        margin: 1rem auto;
      }

      .hamburger::before,
      .hamburger::after {
        background-color: #ffa600;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.5s ease-in-out;
      }

      .hamburger::before {
        top: 0.4em;
      }

      .hamburger::after {
        bottom: 0.35em;
      }
    }

    input {
      display: none;
    }

    input:checked ~ nav {
      top: 3rem;
    }

    input:checked ~ label {
      .hamburger {
        transform: rotate(45deg);
      }

      .hamburger::before,
      .hamburger::after {
        transform: rotate(90deg);
        top: 0;
      }
    }

    input:checked ~ ul {
      left: 0;
    }

    a {
      img {
        height: 3rem;
      }
    }

    ul {
      margin: 0;
      background-color: #005516;
      list-style: none;
      position: absolute;
      padding: 0;
      text-align: center;
      width: 100%;
      height: 100%;
      top: 6.5rem;
      left: -100%;
      transition: 0.2s linear;
      z-index: 1000;

      li {
        margin: 0rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-end;
        gap: 0.5rem;

        a {
          padding: 0 0.7rem;
          color: #efefef;
          text-decoration: none;
          font-size: 1rem;
          font-family: "Montserrat-Medium";
          color: white;
        }

        a:hover {
          text-decoration: none;
          color: #ffa600;
        }
      }

      .divider {
        display: none;
        border: 1px solid rgba(187, 187, 187, 0.946);
        margin-top: 1.7rem;
        height: 2rem;
      }
    }
  }
}

 @media screen and (min-width: 950px) and (max-width: 1149px) {
  .contador-espaco {
        margin-right: 30px; 
  }
  .gridbox {
    display: grid;
    gap: 0.3rem;
    align-items: flex-end;
    height: max-content;
    margin-top: 0.3rem;
  }

  header {
    .usuario {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0.5rem 0.7rem;

      p {
        margin: 0.1rem 0 0 0;
        font-size: 0.9rem;
        color: white;
      }

      .sair {
        height: 0.9rem;
      }

      a {
        margin-left: 0.5rem;
      }
    }

    .versao {
      margin: 0.5rem 0.7rem;
    }

    nav {
      background-color: #005516;

      .centro {
        display: flex;
        justify-content: space-between;
        max-width: 80rem;
        padding: 0;
        align-items: center;
      }

      span {
        color: white;
        font-size: 0.9rem;
      }

      a {
        img {
          height: 1rem;
        }
      }
    }
  }

  .faixa-menu {
    background-color: #005516;

    .centro {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 95rem;
      min-height: 3rem;
      height: auto !important; /* É essa linha que destrava o fundo verde no monitor de 1440px! */
      padding: 0.5rem 0;       /* Adiciona um respiro em cima e embaixo */
    }

    .icon-mov {
      background-color: #efefef;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;
    }

    .logo {
      margin: .3rem 0;
      img {
        height: 4rem;
        width: auto;
      }
    }
    .logo_menu {
      margin: .3rem 0;
      img {
        height: 6rem;
        width: auto;
      }
    }

    .menu {
      border-radius: 50%;
      width: 2rem;
      height: 2rem;
      position: absolute;
      left: 0.5rem;
      top: 3.5rem;
      z-index: 3;
      cursor: pointer;

      .hamburger {
        display: block;
        background-color: #ffa600;
        width: 1.4rem;
        height: 2px;
        position: relative;
        z-index: 12;
        margin: 1rem auto;
      }

      .hamburger::before,
      .hamburger::after {
        background-color: #ffa600;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.5s ease-in-out;
      }

      .hamburger::before {
        top: 0.4em;
      }

      .hamburger::after {
        bottom: 0.35em;
      }
    }

    input {
      display: none;
    }

    input:checked ~ nav {
      top: 3rem;
    }

    input:checked ~ label {
      .hamburger {
        transform: rotate(45deg);
      }

      .hamburger::before,
      .hamburger::after {
        transform: rotate(90deg);
        top: 0;
      }
    }

    input:checked ~ ul {
      left: 0;
    }

    a {
      img {
        height: 3rem;
      }
    }

    ul {
      margin: 0;
      background-color: #005516;
      list-style: none;
      position: absolute;
      padding: 0;
      text-align: center;
      width: 100%;
      height: 100%;
      top: 6.5rem;
      left: -100%;
      transition: 0.2s linear;
      z-index: 1000;

      li {
        margin: 0rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-end;
        gap: 0.2rem;

        a {
          padding: 0 0.7rem;
          color: #efefef;
          text-decoration: none;
          font-size: 0.95rem;
          font-family: "Montserrat-Medium";
          color: white;
        }

        a:hover {
          text-decoration: none;
          color: #ffa600;
        }
      }

      .divider {
        display: none;
        border: 1px solid rgba(187, 187, 187, 0.946);
        margin-top: 1.7rem;
        height: 2rem;
      }
    }
  }
}

 @media screen and (min-width: "50em") {

  .logo {
    width: 15rem;
    margin-bottom: 0.5rem;

    .router-link-active {
      border-bottom: solid 0.17rem #efefef;
    }

    .router-link:hover {
      border-bottom: none;
    }
  }

  .router-link-active {
    border-bottom: solid 0.17rem #ffa600;
  }

  .router-link-active:hover {
    border-bottom: solid 0.17rem #ffa600;
  }

  header {
    .faixa-menu {
      .menu {
        display: none;
      }

      ul {
        position: static;
        display: flex;
        background-color: transparent;
        justify-content: flex-start;
        align-self: center;
        width: fit-content;

        li {
          margin-bottom: 0;
        }

        a {
          color: #efefef;
          padding: 0.5rem 1rem 0.2rem 0.5rem;
          margin-bottom: 0.2rem;
        }

        a:hover {
          border-bottom: #ffa600 solid 0.15rem;
        }
      }

      img {
        height: 4rem;
      }
    }
  }
}

 @media screen and (min-width: 800px) and (max-width: 949px) {
  .contador-espaco {
        margin-right: 30px; 
    }
  .gridbox {
    display: grid;
    gap: 0.2rem;
    align-items: flex-end;
    height: max-content;
    margin: 0.3rem 0rem 0.3rem 0rem;
  }

  header {
    .usuario {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0.5rem 0.7rem;

      p {
        margin: 0.1rem 0 0 0;
        font-size: 0.9rem;
        color: white;
      }

      .sair {
        height: 0.9rem;
      }

      a {
        margin-left: 0.5rem;
      }
    }

    .versao {
      margin: 0.5rem 0.7rem;
    }

    nav {
      background-color: #005516;

      .centro {
        display: flex;
        justify-content: space-between;
        max-width: 80rem;
        padding: 0;
        align-items: center;
      }

      span {
        color: white;
        font-size: 0.9rem;
      }

      a {
        img {
          height: 1rem;
        }
      }
    }
  }

  .faixa-menu {
    background-color: #005516;

    .centro {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 95rem;
      min-height: 2rem;
      height: auto !important; /* É essa linha que destrava o fundo verde no monitor de 1440px! */
      padding: 0.5rem 0;       /* Adiciona um respiro em cima e embaixo */
    }

    .icon-mov {
      background-color: #efefef;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;
    }

    .logo {
      margin: .3rem 0;
      img {
        height: 4rem;
        width: auto;
      }
    }
    .logo_menu {
      margin: .3rem 0;
      img {
        height: 6rem;
        width: auto;
      }
    }

    .menu {
      border-radius: 50%;
      width: 2rem;
      height: 2rem;
      position: absolute;
      left: 0.5rem;
      top: 3.5rem;
      z-index: 3;
      cursor: pointer;

      .hamburger {
        display: block;
        background-color: #ffa600;
        width: 1.4rem;
        height: 2px;
        position: relative;
        z-index: 12;
        margin: 1rem auto;
      }

      .hamburger::before,
      .hamburger::after {
        background-color: #ffa600;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.5s ease-in-out;
      }

      .hamburger::before {
        top: 0.4em;
      }

      .hamburger::after {
        bottom: 0.35em;
      }
    }

    input {
      display: none;
    }

    input:checked ~ nav {
      top: 3rem;
    }

    input:checked ~ label {
      .hamburger {
        transform: rotate(45deg);
      }

      .hamburger::before,
      .hamburger::after {
        transform: rotate(90deg);
        top: 0;
      }
    }

    input:checked ~ ul {
      left: 0;
    }

    a {
      img {
        height: 3rem;
      }
    }

    ul {
      padding: 0;
      margin: 0;

      li {
        margin: 0rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-end;
        gap: 0.2rem;

        a {
          padding: 0 0.7rem;
          color: #efefef;
          text-decoration: none;
          font-size: 0.95rem;
          font-family: "Montserrat-Medium";
          color: white;
        }

        a:hover {
          text-decoration: none;
          color: #ffa600;
        }
      }

      .divider {
        display: none;
        border: 1px solid rgba(187, 187, 187, 0.946);
        margin-top: 1.7rem;
        height: 2rem;
      }
    }
  }
}

 @media screen and (min-width: 680px) and (max-width: 799px) {
  .contador-espaco {
        margin-right: 30px; 
    }
  .gridbox {
    display: grid;
    gap: 0.2rem;
    align-items: flex-end;
    height: max-content;
    margin: 0.3rem 0;
  }

  header {
    .usuario {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0.5rem 0.7rem;

      p {
        margin: 0.1rem 0 0 0;
        font-size: 0.9rem;
        color: white;
      }

      .sair {
        height: 0.9rem;
      }

      a {
        margin-left: 0.5rem;
      }
    }

    .versao {
      margin: 0.5rem 0.7rem;
    }

    nav {
      background-color: #005516;

      .centro {
        display: flex;
        justify-content: space-between;
        max-width: 80rem;
        padding: 0;
        align-items: center;
      }

      span {
        color: white;
        font-size: 0.9rem;
      }

      a {
        img {
          height: 1rem;
        }
      }
    }
  }

  .faixa-menu {
    background-color: #005516;

    .centro {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 95rem;
      min-height: 3rem;
      height: auto !important; /* É essa linha que destrava o fundo verde no monitor de 1440px! */
      padding: 0.5rem 0;       /* Adiciona um respiro em cima e embaixo */
    }

    .icon-mov {
      background-color: #efefef;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;
    }

    .logo {
      margin: .3rem 0;
      img {
        height: 4rem;
        width: auto;
      }
    }
    .logo_menu {
      margin: .3rem 0;
      img {
        height: 6rem;
        width: auto;
      }
    }

    .menu {
      border-radius: 50%;
      width: 2rem;
      height: 1rem;
      cursor: pointer;

      .hamburger {
        display: block;
        background-color: #ffa600;
        width: 1.4rem;
        height: 2px;
        position: relative;
        z-index: 12;
        margin: 1rem auto;
      }

      .hamburger::before,
      .hamburger::after {
        background-color: #ffa600;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.5s ease-in-out;
      }

      .hamburger::before {
        top: 0.4em;
      }

      .hamburger::after {
        bottom: 0.35em;
      }
    }

    input {
      display: none;
    }

    input:checked ~ nav {
      top: 3rem;
    }

    input:checked ~ label {
      .hamburger {
        transform: rotate(45deg);
      }

      .hamburger::before,
      .hamburger::after {
        transform: rotate(90deg);
        top: 0;
      }
    }

    input:checked ~ ul {
      left: 0;
    }

    a {
      img {
        height: 3rem;
      }
    }

    ul {
      background-color: #005516;
      list-style: none;
      position: absolute;
      padding: 0;
      text-align: center;
      width: 100%;
      height: 100%;
      top: 21rem;
      left: -100%;
      transition: 0.2s linear;
      z-index: 1000;

      li {
        margin: 2rem auto;
        display: grid;

        a {
          color: #efefef;
          text-decoration: none;
          font-size: 1.1rem;
          font-family: "Montserrat-Medium";
          color: white;
          margin: 1rem 0;
        }

        a:hover {
          text-decoration: none;
          color: #ffa600;
        }
      }

      .divider {
        display: none;
        border: 1px solid rgba(187, 187, 187, 0.946);
        margin-top: 1.7rem;
        height: 2rem;
      }
    }
  }
}

 @media screen and (min-width: 60px) and (max-width: 679px) {
  
  header {
    .usuario {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0.5rem 0.7rem;

      p {
        margin: 0.1rem 0 0 0;
        font-size: 0.8rem;
        color: white;
      }

      .sair {
        height: 0.8rem;
      }

      a {
        margin-left: 0.5rem;
      }
    }

    .versao {
      margin: 0.5rem 0.7rem;
    }

    nav {
      background-color: #005516;

      .centro {
        display: flex;
        justify-content: space-between;
        max-width: 80rem;
        padding: 0;
        align-items: center;
      }

      span {
        color: white;
        font-size: 0.8rem;
      }

      a {
        img {
          height: 1rem;
        }
      }
    }
  }

  .faixa-menu {
    background-color: #005516;

    .centro {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 95rem;
      min-height: 3rem;
      height: auto !important; /* É essa linha que destrava o fundo verde no monitor de 1440px! */
      padding: 0.5rem 0;       /* Adiciona um respiro em cima e embaixo */
    }

    .icon-mov {
      background-color: #efefef;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 1rem;
    }

    .logo {
      margin: .3rem 0;
      img {
        height: 4rem;
        width: auto;
      }
    }
    .logo_menu {
      margin: .3rem 0;
      img {
        height: 6rem;
        width: auto;
      }
    }

    .menu {
      border-radius: 50%;
      width: 2rem;
      height: 1rem;
      cursor: pointer;

      .hamburger {
        display: block;
        background-color: #ffa600;
        width: 1.4rem;
        height: 2px;
        position: relative;
        z-index: 12;
        margin: 1rem auto;
      }

      .hamburger::before,
      .hamburger::after {
        background-color: #ffa600;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.5s ease-in-out;
      }

      .hamburger::before {
        top: 0.4em;
      }

      .hamburger::after {
        bottom: 0.35em;
      }
    }

    input {
      display: none;
    }

    input:checked ~ nav {
      top: 3rem;
    }

    input:checked ~ label {
      .hamburger {
        transform: rotate(45deg);
      }

      .hamburger::before,
      .hamburger::after {
        transform: rotate(90deg);
        top: 0;
      }
    }

    input:checked ~ ul {
      left: 0;
    }

    a {
      img {
        height: 3rem;
      }
    }

    ul {
      background-color: #005516;
      list-style: none;
      position: absolute;
      padding: 0;
      text-align: center;
      width: 100%;
      height: 100%;
      top: 24.7rem;
      left: -100%;
      transition: 0.2s linear;
      z-index: 1000;

      li {
        margin: 2rem auto;
        display: grid;

        a {
          color: #efefef;
          text-decoration: none;
          font-size: 1.1rem;
          font-family: "Montserrat-Medium";
          color: white;
          margin: 1rem 0;
        }

        a:hover {
          text-decoration: none;
          color: #ffa600;
        }
      }

      .divider {
        display: none;
        border: 1px solid rgba(187, 187, 187, 0.946);
        margin-top: 1.7rem;
        height: 2rem;
      }
    }
  }
}
/* AFINAR A FAIXA VERDE SUPERIOR EM TODAS AS TELAS */
header nav .topo-menu .usuario,
header nav .topo-menu .versao {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

header nav .topo-menu .gridbox {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* AFINAR A FAIXA VERDE PRINCIPAL DO MENU EM TODAS AS TELAS */
header .faixa-menu .centro {
  margin-top: 0;
  min-height: 0 !important; 
  padding: 0 !important;
}

/* Ajusta a caixinha das logos no celular */
header .faixa-menu .icon-mov {
  padding: 0.1rem 1rem !important;
}
</style>